import { useEffect } from "react";
import { useSettings } from "../providers/SettingsProvider";

/**
 * Side-effect-only component. Renders nothing. Sets CSS vars on all
 * .wahchan-app roots when settings load. Guards against `undefined`
 * being written to CSS.
 */
export default function ThemeBootstrap() {
    const { settings } = useSettings();

    useEffect(() => {
        if (!settings) return;
        const primary = settings.ifm_NaturalPrimaryColor;
        const fg = settings.ifm_NaturalFontColor;
        if (!primary) return;

        const roots = document.querySelectorAll(".wahchan-app");
        roots.forEach((root) => {
            root.style.setProperty("--doc-natural-primary-color", primary);
            if (fg) {
                root.style.setProperty("--doc-natural-primary-font-color", fg);
            }
            root.style.setProperty(
                "--doc-natural-primary-light-color",
                `${primary}80`
            );
        });
    }, [settings]);

    return null;
}
